import { db } from './firebase';
import { doc, getDoc, setDoc, deleteDoc, collection, getDocs, updateDoc } from 'firebase/firestore';
import { UserProfile, SavedChat } from '../types';

export const saveUserProfile = async (userId: string, profile: UserProfile) => {
  try {
    // setDoc with merge: true ensures we don't overwrite existing fields if we send partial data
    await setDoc(doc(db, 'users', userId), profile, { merge: true });
  } catch (error) {
    console.error("Error saving user profile:", error);
    throw error;
  }
};

export const updateUserSubscription = async (userId: string, planType: 'trial' | 'monthly' | 'yearly', expiryDate: number) => {
  try {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      planType: planType,
      subscriptionExpiryDate: expiryDate
    });
  } catch (error) {
    console.error("Error updating subscription:", error);
    throw error;
  }
};

export const getUserProfile = async (userId: string): Promise<UserProfile | null> => {
  try {
    const docRef = doc(db, 'users', userId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data() as UserProfile;
    }
    return null;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return null;
  }
};

export const saveChat = async (userId: string, chat: SavedChat) => {
  try {
    // Store chat in a subcollection: users/{userId}/chats/{chatId}
    await setDoc(doc(db, 'users', userId, 'chats', chat.id), chat);
  } catch (error) {
    console.error("Error saving chat:", error);
  }
};

export const deleteChat = async (userId: string, chatId: string) => {
  try {
    await deleteDoc(doc(db, 'users', userId, 'chats', chatId));
  } catch (error) {
    console.error("Error deleting chat:", error);
    throw error;
  }
};

export const getUserChats = async (userId: string): Promise<SavedChat[]> => {
  try {
    const chatsRef = collection(db, 'users', userId, 'chats');
    const querySnapshot = await getDocs(chatsRef);
    const chats: SavedChat[] = [];
    querySnapshot.forEach((doc) => {
      chats.push(doc.data() as SavedChat);
    });
    // Sort in memory (newest first)
    return chats.sort((a, b) => b.lastUpdated - a.lastUpdated);
  } catch (error) {
    console.error("Error fetching chats:", error);
    return [];
  }
};